import siteMessage from "@insite/client-framework/SiteMessage";
import Typography from "@insite/mobius/Typography";
import Group from "@midland-industries/Components/Group";
import { colors } from "@midland-industries/Styles/colors";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

const ShowMessageCss = css`
    position: initial;
    visibility: initial;
    opacity: 1;
    transition: opacity 1s ease;
`;

const HideMessageCss = css`
    position: absolute;
    visibility: hidden;
    opacity: 0;
`;

const PromiseBanner: React.FC = () => {
    const messages = ["PromiseBanner_1", "PromiseBanner_2", "PromiseBanner_3"];
    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            if (messageIndex === 2) {
                setMessageIndex(0);
            } else {
                setMessageIndex(messageIndex + 1);
            }
        }, 5000);
    }, [messageIndex]);

    return (
        <Group
            align="center"
            justify="center"
            style={{ width: "100%", padding: "6px 0", background: colors.accent, position: "relative", zIndex: 1 }}
        >
            <Typography
                size={15}
                lineHeight="24px"
                color={colors.textMain}
                css={messageIndex === 0 ? ShowMessageCss : HideMessageCss}
            >
                {siteMessage(messages[0])}
            </Typography>
            <Typography
                size={15}
                lineHeight="24px"
                color={colors.textMain}
                css={messageIndex === 1 ? ShowMessageCss : HideMessageCss}
            >
                {siteMessage(messages[1])}
            </Typography>
            <Typography
                size={15}
                lineHeight="24px"
                color={colors.textMain}
                css={messageIndex === 2 ? ShowMessageCss : HideMessageCss}
            >
                {siteMessage(messages[2])}
            </Typography>
        </Group>
    );
};

export default PromiseBanner;
